<img src="{{ baseUrl }}{{ hash }}?s={{ size }}&d=mm" />